// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel-module--carousel---J_TJ","wrapper":"carousel-module--wrapper--IQVHA"};